import {appendQueryParam} from '@js/helpers/location';
import {routes} from "@js/helpers/routes";

export function getSearchFormParams(isDesktopForm = true) {
    const $filterForm = isDesktopForm ? $('form.ranking-filters').not($('#modal-filter-form')) : $('#modal-filter-form');
    return `${$filterForm
        .serialize()}&${$('#mode-form')
        .serialize()}`;
}

export function getRankingId() {
    return $('#rankingId').val();
}

export function refreshRankingPage(isDesktopForm = true) {
    let queryParams = getSearchFormParams(isDesktopForm);

    const $rankingTable = $('.ranking-table');
    const sortingType = $rankingTable.attr('data-sorting-type');
    if (sortingType) {
        const $column = $rankingTable.find('th.sorting-column--active');
        const sortingColumn = $column.attr('data-sorting-column');
        queryParams = appendQueryParam(queryParams, 'sort_by', sortingColumn);
        queryParams = appendQueryParam(queryParams, 'sort_type', sortingType);
    }
    refreshPageWithParams(queryParams);
}

export function refreshPageWithParams(queryParams) {
    window.location.search = queryParams;
}

export function initLockFilterYear() {
    const loginUrl = routes.public.login();
    const $tooltip = $('.lock-year');
    if ($tooltip.length) {
        $tooltip.tooltip({
            html: true,
            title: 'Доступно <a href="' + loginUrl + '">зарегистрированным</a> пользователям',
            placement: 'bottom',
            delay: {
                "show": 0,
                "hide": 3000
            }
        });
    }
}

export function initSelectsWithLiveSearch() {
    const $selectsWithLiveSearch = $('.select-with-live-search');
    if ($selectsWithLiveSearch.length) {
        $selectsWithLiveSearch.selectpicker({
            noneResultsText: 'По запросу {0} ничего не найдено',
            noneSelectedText: 'Все',
            size: 20,
        });
        // todo Артём сделаю множ. выбор по округам в фильтре региона когда буду посвободнее
        // .on('loaded.bs.select', function () {
        //     const $select = $(this);
        //     if ($(this).attr('name') === 'regions[]') {
        //         // $select
        //         //     .on('click', 'optgroup', function () {
        //         //         console.log($(this));
        //         //         $(this).child('option').prop('selected', true);
        //         //     });
        //         const $selectDropdown = $select.closest('.bootstrap-select')
        //             .find('.dropdown-menu.open');
        //         console.log($selectDropdown);
        //         $selectDropdown
        //             .on('click', '.dropdown-header', function () {
        //                 console.log($(this));
        //                 $selectDropdown.child('li').addClass('selected');
        //             });
        //     }
        //
        // });
    }
    $('#filters, .ranking-filters')
        .on('click', '[data-id="regions"]', (e) => {
            const $select = $(e.currentTarget);
            const $selectDropdown = $select.closest('.sidebar__filter')
                .find('.dropdown-menu.open');
            const selectHeight = parseInt($selectDropdown.css('max-height'), 10);
            const innerHeight = parseInt($selectDropdown.find('.inner.open').css('max-height'), 10);
            if (selectHeight - innerHeight < 80) {
                $selectDropdown.css('max-height', innerHeight + 80);
            }
        });
}
